var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"no-body":""}},[_c('div',{attrs:{"id":"chart"}},[_c('VueApexCharts',{staticStyle:{"margin-left":"18%"},attrs:{"type":"pie","width":"380","options":_vm.chartOptions,"series":_vm.series}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }